import { authActions, pairingActions } from '@lifesize/nucleus';

import { selectIsImpersonating } from 'selectors/impersonationSelectors';
import { getUrlParameter } from 'utils/url-utils';
import { setImpersonationSessionActive } from './impersonationActions';
import { fetchRecordingsAuth } from './recordingsAuthActions';
import { fetchSsoStatus } from './ssoActions';

export const INITIALIZE_CLIENT_APPLICATION = 'INITIALIZE_CLIENT_APPLICATION';

export const initializeClient = () => (dispatch: Function, getState: Function) => {
  const state = getState();
  const isImpersonating = selectIsImpersonating(state);
  if (!isImpersonating) {
    dispatch(fetchRecordingsAuth());
  }
  dispatch(fetchSsoStatus());
  dispatch(pairingActions.subscribeToLinking());
};

export const login = () => async (dispatch: Function) => {
  // Dispatch login action
  const impersonationToken = getUrlParameter('impersonationToken'); // Obtain impersonation token from url parameter.
  const aCookie = getUrlParameter('a'); // Obtain a cookie from url parameter
  const jwt = impersonationToken || aCookie;
  const loginParams = jwt ? { jwt } : {};
  await dispatch(authActions.login(loginParams));

  // If we used an impersonation token, need to dispatch an action to identify the session as impersonation
  if (impersonationToken) {
    dispatch(setImpersonationSessionActive());
  }
};
